// Loaded from CDN and included in externals in webpack.config.js
import MathJax from "mathjax";

// Required JS from node_modules
import dayjs from "dayjs";

// Required JS from local files
import {
   Context,
   addInitialFunction,
   buildCourseSelectElement,
   dfmAlert,
   dfmAlertInverted,
   dfmConfirm,
   dfmDialog,
   dfmTaskSetter,
   formatTime,
   formatVideoLength,
   getAccuracyColour,
   getSubskillFullName,
   getSubskillLabel,
   getUTCFromDateAndTime,
   isParent,
   isStudent,
   isTeacher,
   isTrustAdmin,
   limitLength,
   numberWithCommas,
   readFriendlyDate,
   redirectToRequiredLogin,
   reportQuestionError,
   timeSince
} from "./dfm5";
import {
   dfm_generateQuestionContent,
   insertHTMLAnswer,
   replaceMathsTags
} from "./question-util";
import { openVideo } from "./util-videos";
import { formatRelativeDateTime } from "~/utils/datetime";
import { posthogEventTaskSetWorkLinkClicked } from "~/utils/posthog/tasks";
import {
   getLatestFeedbackByQuestion,
   getUserAnswer,
   markAllFeedbackAsRead,
   markFeedbackAsRead
} from "~/utils/tasks";

// CSS
import "./progress.css";

$(document).ready(function() {
   console.log("[InitiatingProgressInterface]");

   $("#progress-menu").dfmSideMenu({
      panels: $("#progress-content"),
      onSelect: function(tab) {
         respondToProgressTabSelection(tab);
      }
   });
   $(".teacheronly").hide(); // will be show once user login authenticated
   $(".studentonly").hide();

   addInitialFunction(redirectToRequiredLogin);
   addInitialFunction(initialiseProgressComponents);
});

function respondToProgressTabSelection(tab) {
   // Reset state of feedback UI
   feedbackQuestionContainer.hide();

   if(tab=="tabs-tasklist") {
      loadTaskList();
   } else if(tab=="tabs-taskmarksheet") {
      loadMarksheet();
   } else if(tab=="tabs-studentprogress" && isStudent()) {
      loadProgressStatistics();
   } else if(tab=="tabs-leaderboards") {
      loadLeaderboards();
   } else if(tab=="tabs-feedback") {
      loadFeedbackPane();
   }
}

function initialiseProgressComponents() {

   if(!isStudent()) {
      $(".teacheronly").show();
   }
   else {
      $(".teacheronly").remove();
      $(".studentonly").show();
      $("a[href='#tabs-studentprogress']").html("My Progress");
      $("#tabs-studentprogress > h1").html("My Progress");
      if(!Context.user.sid || (Context.user._school && Context.user._school.leaderboardoptout==2)) {
         $("a[href='#tabs-leaderboards']").parent().remove();
      }
   }

   $("#progress-tasklist-students").studentSelector({onChange: loadTaskList, defaultLabel: "Choose students/classes"});
   if(isStudent()) {
      $("#progress-tasklist-students").studentSelector("setValue", {uids: [Context.user.uid]});
      $("#progress-tasklist-students").next().hide(); // don't show student selector element for students.
   }


   if(!isStudent()) {
      $("#progress-marksheet-students").studentSelector({onChange: loadMarksheet, classesOnly: true, defaultLabel: "Choose students/classes"});
      // $("#progress-marksheet-students").studentSelector("setValue", {uids: [Context.user.uid]});
      // $("#progress-marksheet-students").next().hide(); // don't show student selector element for students.
   }

   $("#studentprogress-header-students").studentSelector({
      onChange: function() {
         loadProgressStatistics();
         if ($("#studentprogress-tabs").dfmTabs("getTab")=="progress-activity") {
            loadActivityLog();
         }
         // Only show the student progress tabs and pane if we have a selection of students.
         if ($("#studentprogress-header-students").val() && $("#studentprogress-header-students").val() !== "{}") {
            $("#studentprogress-tabs").show();
            $("#studentprogress-panes").show();
         } else {
            $("#studentprogress-tabs").hide();
            $("#studentprogress-panes").hide();
         }
      },
      defaultLabel: "Choose students/classes"
   });

   if(isStudent()) {
      $("#studentprogress-header-students").studentSelector("setValue", {uids: [Context.user.uid]});
      $("#studentprogress-header-students").next().hide();
      $("#studentprogress-tabs").show();
      $("#studentprogress-panes").show();
   }

   $.datepicker.setDefaults(
     $.extend(
        {'dateFormat':'dd/mm/yy'},
        $.datepicker.regional['uk']
     )
   );
   var lastAugust = new Date();
   lastAugust.setMonth(7); // august
   lastAugust.setDate(20); // 20th
   if(lastAugust > (new Date()))lastAugust.setFullYear(lastAugust.getFullYear()-1);
   var lastAugustStr = lastAugust.getDate()+"/"+(lastAugust.getMonth()+1)+"/"+lastAugust.getFullYear();
   var nextWeek = new Date();
   nextWeek.setDate(nextWeek.getDate()+7);
   var nextWeekStr = nextWeek.getDate()+"/"+(nextWeek.getMonth()+1)+"/"+nextWeek.getFullYear();

   $("#progress-tasklist-datefrom").val(lastAugustStr).change(loadTaskList);
   $("#progress-tasklist-dateto").val(nextWeekStr).change(loadTaskList);
   $("#progress-tasklist-datefrom").datepicker();
   $("#progress-tasklist-dateto").datepicker();
   $("#progress-marksheet-datefrom").val(lastAugustStr).change(loadMarksheet);
   $("#progress-marksheet-dateto").val(nextWeekStr).change(loadMarksheet);
   $("#progress-marksheet-datefrom").datepicker();
   $("#progress-marksheet-dateto").datepicker();
   $("#progress-activity-datefrom").val(lastAugustStr).change(loadActivityLog);
   $("#progress-activity-dateto").val(nextWeekStr).change(loadActivityLog);
   $("#progress-activity-datefrom").datepicker();
   $("#progress-activity-dateto").datepicker();
   $("#progress-activity-type").change(loadActivityLog);

   $("#leaderboards-datefilter > div").hide();
   $("#leaderboards-datefilter > a").click(function(){
      $(this).hide();
      $("#leaderboards-datefilter > div").show();
   });
   $("#leaderboard-points-help").click(function(){
      dfmAlert("Students earn 2-5 points per question depending on its difficulty. This never maxes out for any skill, although they may stop earning points while to repeatedly answer the same kind of question.");
   });
   $("#leaderboard-mastery-help").click(function(){
      dfmAlert("For every skill, each student has a mastery value between 0 and 100, which goes up and down as they get questions correct and incorrect. Students must answer harder questions within a skill to up their mastery once their mastery gets higher. For example, if difficulty varies on a skill between 1 and 4, they're limited to a mastery of 25 by answering difficulty 1 questions, limited to 50 by answering difficulty 2 questions, and so on.<br><br><strong>Note that mastery will not be displayed if you filter to a date range.</strong>");
   });

   $("#progress-summary-datefrom").val(lastAugustStr).change(loadProgressStatistics);
   $("#progress-summary-dateto").val(nextWeekStr).change(loadProgressStatistics);
   $("#progress-summary-datefrom").datepicker();
   $("#progress-summary-dateto").datepicker();
   $("#progress-summary-grouping").change(loadProgressStatistics);


   $("#progress-tasklist-studentattempts-header-back").click(closeStudentAttempt);
   $("#progress-tasklist-analysis-header-back").click(closeTaskAnalysis);
   $("#progress-tasklist-analysis-save").click(function(){
      dfmAlertInverted(""
          +"<div class='dialog-options'><h1>Export to Excel</h1>"
          +"<div><button id='output-qla'>QLA</button><p id='output-qla-label'>Generates a table for each student, detailing the skills in each questions and the marks the received for each question.</p></div>"
          +"<div><button id='output-fullbreakdown'>Full Breakdown</button><p>A table resembling the Full Breakdown view.</p></div>"
          +"</div>");
      var task = $('body').data('task');
      if(!task.wid) {
         $("#output-qla").prop('disabled', true);
         $("#output-qla-label").append("<br><small>Available only for fixed question tasks.</small>").addClass('disabled');
      }
      $("#output-qla").click(function(){
         window.location = '/api/progress/qla/'+task.aid;
         $.modal.close();
         dfmAlert("Generating QLA. Please wait...");
         return false;
      });
      $("#output-fullbreakdown").click(function(){
         window.location = "/api/tasks/analysis/"+task.aid+"?format=excel";
      });
   });
   $("#progress-tasklist-analysis-edit").click(function(){
      console.log(JSON.stringify( $('body').data('task') ));
      dfmTaskSetter({
         isPractice: false,
         task: $('body').data('task'),
         callback: function(){
            loadTask($('body').data('task').aid, true)
         },
         notice: "If you want to set the task to someone who has joined the class, ensure you leave the original recipients or the task will be unset from them. It is easier to retrospectively assign existing tasks to a new student from the Marksheet tab."
      });
   });


   $("#analysis-byquestion-sort").change(loadAnalysisByQuestion);

   $("#progress-bycourse > div").hide();

   $("#progress-tasklist-analysis-tabs").dfmTabs($("#progress-tasklist-analysis-main"));
   $("#progress-tasklist-analysis-tabs").dfmTabs("setListener", function(){
      var tab = $("#progress-tasklist-analysis-tabs").dfmTabs("getTab");
      $("#progress-tasklist-analysis-headercontainer").css('width','100%');
      if(tab=="analysis-byquestion")loadAnalysisByQuestion();
   });
   $("#progress-tasklist-analysis-refresh").click(reloadTaskAnalysis);
   $("#progress-marksheet-refresh").click(loadMarksheet);
   $("#progress-marksheet-save").click(function(){
      exportMarksheet();
   });

   $("#studentprogress-tabs").dfmTabs($("#studentprogress-panes"));
   $("#studentprogress-tabs").dfmTabs("setListener", function(){
      var tab = $("#studentprogress-tabs").dfmTabs("getTab");
      if(tab=="progress-activity")loadActivityLog();
   });

   for(var i=0; i<=3; i++) {
      $("#progress-summary-masterycounts"+i+" .bars").dfmMasteryBar();
   }
   $("#progress-summary-byindividual .bars").each(function(){
      $(this).dfmMasteryBar();
   });
   $("#progress-summary-byindividual").hide();
   if(isStudent()) {
      $("#progress-summary-grouping").hide();
   }

   if(Context.user?.sid) {
      $("#leaderboards-classselection").studentSelector({onChange: function(){
            loadLeaderboards();
         }, "classesOnly": true, "includeMulticlassGroups": true, onLoad: function(){
            console.log("[ClassesOnload]");
            $("#leaderboards-classselection").studentSelector("setValue", {cids: [0]}); // 0 = whole school
         }});
      $("#leaderboards-sortby").change(loadLeaderboards);
      $("#leaderboards-datefrom").datepicker().change(loadLeaderboards);
      $("#leaderboards-dateto").datepicker().change(loadLeaderboards);
      $("#progress-leaderboards-save").click(exportLeaderboard);
   }

   if(isParent()) {
      $("a[href='#tabs-leaderboards']").remove();
   }

   if(preloadState && Object.keys(preloadState).length>0)loadFromPageState(preloadState, false);
   else if(Context.user?.sid || isParent()) {
      $("#progress-menu").dfmSideMenu("selectTab", "tabs-tasklist");
   } else {
      $("#progress-menu").dfmSideMenu("selectTab", "tabs-studentprogress");
   }

}

function getLeaderboardData(toExport) {
   // Usual format of student/class selection is {uids: ..., cids: ...}, but we just want the one class.
   const classSelectionVal = $("#leaderboards-classselection").val();
   const classSelection = classSelectionVal ? JSON.parse(classSelectionVal) : {};
   if (classSelection.cids?.length === 1) {
      const cid = JSON.parse($("#leaderboards-classselection").val()).cids[0];
      const sortby = $("#leaderboards-sortby").val();
      let data = { cid, sortby, format: (toExport ? "excel" : "json") }
      if($("#leaderboards-datefrom").val() && $("#leaderboards-dateto").val()) {
         const datefrom = getUTCFromDateAndTime($("#leaderboards-datefrom").val(), "00:00:00");
         const dateto = getUTCFromDateAndTime($("#leaderboards-dateto").val(), "23:59:59");
         data.from = datefrom;
         data.to = dateto;
      }
      return data;
   } else {
      return null
   }
}

function exportLeaderboard() {
   const data = getLeaderboardData(true)
   if (data) {
      const json = JSON.stringify(data);
      let xhr = new XMLHttpRequest();
      xhr.open('POST', '/api/progress/leaderboard', true);
      xhr.responseType = 'blob';
      xhr.onload = function (e) {
          var blob = e.currentTarget.response;
          var contentDispo = e.currentTarget.getResponseHeader('Content-Disposition');
          var fileName = contentDispo.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1];
          if(fileName[0]=='"')fileName = fileName.substr(1, fileName.length-2);
          console.log("Filename: "+fileName);
          saveBlob(blob, fileName);
      }
      xhr.send(json);
   }
}

function saveBlob(blob, fileName) {
    var a = document.createElement('a');
    a.href = window.URL.createObjectURL(blob);
    a.download = fileName;
    a.dispatchEvent(new MouseEvent('click'));
}

function loadLeaderboards() {

   // Empty the leaderboard table
   const tbody = $("#tabs-leaderboards table tbody");
   tbody.empty();

   // Check that we have valid data from the UI to fetch and build a leaderboard
   const data = getLeaderboardData(false);
   if (data) {
      $.ajax({
         url: "/api/progress/leaderboard",
         type: "POST",
         contentType:false,
         processData: false,
         cache: false,
         data: JSON.stringify(data),
         dataType: "json",
         success: function(data){
            $("#leaderboards-sortby").show();
            $("#leaderboards-datefilter").show();
            $("#progress-leaderboards-buttons").show();
            $.each(data.rows, function(k,row) {
               tbody.append("<tr><td>"+(k+1)+"</td>"
                   +"<td>"+(row.thumb ? "<img src='"+row.thumb+"'>" : "")+row.firstname+" "+row.surname+"<br><small>"+row.ctext+"</small></td>"
                   +"<td>"+(row.mastery ? Math.round(row.mastery) : "")+"</td>"
                   +"<td>"+Math.round(row.totalpoints)+"</td>"
                   +"</tr>");
            });
            $(window).scrollTop(0);
         },
         error: function(j) {
            dfmAlert("An error occurred when trying to get the leaderboard cid="+data.cid+": <strong>"+j.responseText+"</strong>");
         }
      });
   } else {
      $("#leaderboards-sortby").hide();
      $("#leaderboards-datefilter").hide();
      $("#progress-leaderboards-buttons").hide();
   }
}


/**
 * Deletes a task and reloads the task list.
 *
 * @param {number} aid
 * @param {{ uid: number, name: string }?} creator
 */
function deleteTask(aid, creator = null)
{
   // If there is a creator and it is not the current user, show a warning.
   let differentUserWarning = ""
   const { uid: creatorUid, name: creatorName } = creator ?? {};
   if (creatorUid && creatorName) {
      differentUserWarning = creatorUid === Context.user?.uid
         ? ""
         : `<p style="background:#fde68a;padding:8px 10px;font-size:13px;"><b>Warning!</b> You did not set this task. It was created by <b>${creatorName}</b>.`;
   }

   const warning =
      `${differentUserWarning ? differentUserWarning : ""}
      <p>Are you sure you want to delete this task?</p>
      <p>It will also delete all students' attempts at this task and is not retrievable.</p>`;

   dfmConfirm(warning, function(){
      $.ajax({
         url: "/api/tasks/tasks/"+aid,
         type: "DELETE",
         success: function(){
            loadTaskList();
         },
         error: function(j) {
            dfmAlert("An error occurred when trying to delete the task aid="+aid+": <strong>"+j.responseText+"</strong>");
         }
      });

   });
}

function loadTaskList() {
   $("#tabs-tasklist > div").hide();
   $("#progress-tasklist-home").show();
   $("#progress-tasklist-home tbody").empty();

   var data = {};

   if ($("#progress-tasklist-students").val()) {
      data.studentselection = JSON.parse($("#progress-tasklist-students").val());
   } else if (Context.user?.uid) {
      data.setby = Context.user.uid;
   }
   data.datefrom = $("#progress-tasklist-datefrom").val();
   data.dateto = $("#progress-tasklist-dateto").val();
   data.type = ["a", "t", "x", "kt"];
   if (isStudent()) $("#tabs-tasklist thead th").eq(4).html("Accuracy");

   $.ajax({
      url: "/api/tasks/list",
      type: "POST",
      contentType: false,
      processData: false,
      cache: false,
      data: JSON.stringify(data),
      dataType: "json",
      success: function (data) {
         $("#progress-tasklist-home").show();
         $("#progress-tasklist-studentattempts").hide();

         $.each(data.tasks, function (k, task) {
            var setForFuture = task.toschedule;
            var whenSetStr = readFriendlyDate(task.setdate, setForFuture);
            if (setForFuture) whenSetStr += "<br><small><strong>(Scheduled)</strong></small>";
            var dueStr = task.duedate ? readFriendlyDate(task.duedate, true) : "None";
            var completedStr = isStudent() ? (task.numcompleted == 1 ? "<img src='/images/tick_icon.svg'>" : "<img src='/images/cross_icon.svg'>")
                : (task.numcompleted + "/" + task.numoutof);
            let setToList = isStudent() ? "" : "<label>" + (task.settocache ? limitLength(task.settocache, 100) : "-") + "</label>";

            $("#progress-tasklist-home tbody").append("<tr id='progress-taskrow-" + task.aid + "'>"
                + "<td><a href='#'>" + (task.text ? limitLength(task.text, 100) : "-") + "</a><br>" + "<small>" + setToList + getTaskType(task.type) + "</small></td>"
                + "<td>" + whenSetStr + "</td><td>" + dueStr + "</td>"
                + "<td>" + completedStr + "</td>"
                + "<td>" + (task.accuracy >= 0 ? "<span class='accuracy'>" + Math.round(task.accuracy) + "%</span>" : "") + "</td>"
                + "</tr>");
            $("#progress-taskrow-" + task.aid).data('aid', task.aid);
            $("#progress-taskrow-" + task.aid).click(function () {
               var aid = $(this).data('aid');
               posthogFrom = "progress-task-list"
               loadTask(aid, true);
            });
         });
         if (data.tasks.length == 0) {
            $("#progress-tasklist-home tbody").append("<tr><td><p>No matching tasks. Try extending the date range.</p></td></tr>");
         }
         $("#progress-tasklist-home tbody .accuracy").each(function () {
            $(this).dfmAccuracyBar();
         });
         MathJax.typeset();
      },
      error: function (j, textStatus, errorThrown) {
         dfmAlert("An error occurred when trying to get the task list: <strong>" + j.responseText + "</strong>");
      }
   });
}


function getMarksheetAPIData(toExport) {
   var studentselection = JSON.parse($("#progress-marksheet-students").val());
   var datefrom = getUTCFromDateAndTime($("#progress-marksheet-datefrom").val(), "00:00:00");
   var dateto = getUTCFromDateAndTime($("#progress-marksheet-dateto").val(), "23:59:59");
   return {studentselection: studentselection, datefrom: datefrom, dateto: dateto, format: (toExport ? "excel" : "json")};
}

function exportMarksheet() {

   var data = JSON.stringify(getMarksheetAPIData(true));
   var xhr = new XMLHttpRequest();
   xhr.open('POST', '/api/tasks/marksheet', true);
   xhr.responseType = 'blob';
   xhr.onload = function (e) {
       var blob = e.currentTarget.response;
       var contentDispo = e.currentTarget.getResponseHeader('Content-Disposition');
       var fileName = contentDispo.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1];
       if(fileName[0]=='"')fileName = fileName.substr(1, fileName.length-2);
       console.log("Filename: "+fileName);
       saveBlob(blob, fileName);
   }
   xhr.send(data);

}

function loadMarksheet() {

   var studentselection = $("#progress-marksheet-students").val();
   var head = $("#tabs-taskmarksheet table thead");
   var body = $("#tabs-taskmarksheet table tbody");
   head.empty();
   body.empty();

   if(!studentselection) {
      $("#tabs-taskmarksheet .instructional-message").show();
      return false;
   } else {
      $("#tabs-taskmarksheet .instructional-message").hide();
      var data = getMarksheetAPIData();
      $.ajax({
         url: "/api/tasks/marksheet",
         type: "POST",
         contentType:false,
         processData: false,
         cache: false,
         data: JSON.stringify(data),
         dataType: "json",
         success: function(marksheet){
            console.log(JSON.stringify(marksheet.tasks));
            console.log("[MarksheetExecTime] "+marksheet.execTime);
            
            head.append("<th></th>");

            if(marksheet.tasks.length==0) {
               $("#tabs-taskmarksheet table tbody").empty().append("<tr><td>No matching tasks. Try extending the date range.</td></tr>");
               return false;
            }

            $.each(marksheet.tasks, function(k,task) {
               var dueDateStr = "No Due Date";
               if(task.duedate) {
                  const d = new Date(task.duedate*1000);
                  dueDateStr = "Due "+readFriendlyDate(task.duedate);
               }
               head.append("<th id='marksheet-task-"+task.aid+"' class='clickable'><a href='#'>"+limitLength(task.text, 80)+"</a><small>"+getTaskType(task.type)+"</small><small class='duedate'>"+dueDateStr+"</small></th>");
               $("#marksheet-task-"+task.aid).click(function(){
                  returnTo = "marksheet";
                  $("#tabs-taskmarksheet").hide();
                  $("#tabs-tasklist").show(); // change pane without changing tab selection on the left.
                  loadTask(task.aid, true);
               });
            });
            $.each(marksheet.uids, function(k,uid) {
               var student = marksheet.students[uid];
               body.append("<tr id='marksheet-student-"+student.uid+"'><td>"+student.surname+", "+student.firstname+"</td></tr>");
               var row = $("#marksheet-student-"+student.uid);
               $.each(marksheet.tasks, function(k,task) {
                  row.append("<td id='marksheet-student-"+student.uid+"-"+task.aid+"' class='marksheet-cell'></td>");
                  var cell = $("#marksheet-student-"+student.uid+"-"+task.aid);
                  var sAttempts = task.attempts[student.uid];
                  cell.data('student', student);
                  cell.data('task', task);

                  if(sAttempts) {
                     var bestAttempt = getBestAttempt(sAttempts, task);
                     var hasCompletedAny = false;
                     $.each(sAttempts, function(kA, attempt) {
                        if(attempt.complete)hasCompletedAny = true;
                     });
                     // Get last non-empty attempt (if the student didn't answer any questions on last attempts, it'll be 0/0)
                     // Ordinarily the last attempt will have most up-to-date score that reflects previous attempts, UNLESS empty.
                     // while(sAttempts.length>1 && sAttempts[sAttempts.length-1].numcompleted==0)sAttempts.pop();
                     // var lastAttempt = sAttempts[sAttempts.length-1];

                     var outof = task.numquestions ? task.numquestions : bestAttempt.numcompleted;
                     cell.html("<span>"+bestAttempt.numcorrect+"/"+outof+"</span>");
                     cell.addClass('clickable').click(function(){
                        returnTo = "marksheet";
                        $("#tabs-taskmarksheet").hide();
                        $("#tabs-tasklist").show(); // don't want to actually switch tab on left menu.
                        loadStudentAttempts($(this).data('task'), $(this).data('student'));
                        return false;
                     });
                     if(hasCompletedAny) {
                        cell.addClass('complete');
                        cell.css('background-color', getAccuracyColour(100*bestAttempt.numcorrect/outof));
                     }

                     // Only mark lateness based on the initial attempt.
                     const initialAttempt = sAttempts.find(a => !a.reattempt) ?? {};
                     if (initialAttempt.lateMark) {
                        cell.addClass('late');
                     }
                  } else {
                     cell.html("<a href='#'>Assign</a>");
                     cell.addClass('clickable').click(function(){
                        addAssigneeToTask($(this).data('task'), $(this).data('student'));
                        return false;
                     });
                  }
               });
            });

            $("#progress-marksheet-headercontainer").outerWidth(Math.max($("#tabs-taskmarksheet table").outerWidth(), $("#progress-marksheet-header")));
            MathJax.typeset();
         },
         error: function(j) {
            dfmAlert("Error: <strong>"+j.responseText+"</strong>");
         }
      }); 
   }
}

function getBestAttempt(attempts, task) {
   var bestAttempt = null;
   var bestAccuracy = -1;
   $.each(attempts, function(k,attempt) {
      if(bestAttempt==null) {
         bestAttempt = attempt;
         var outof = task.numquestions ? task.numquestions : attempt.numcompleted[0];
         bestAccuracy = attempt.numcorrect / outof;
      }
      else if(attempt.numcompleted[0]>0) {
         var outof = task.numquestions ? task.numquestions : attempt.numcompleted[0];
         var accuracy = attempt.numcorrect / outof;
         if(accuracy > bestAccuracy || (accuracy==bestAccuracy && bestAttempt && attempt.numcompleted[0] > bestAttempt.numcompleted[0])) {
            bestAttempt = attempt;
            bestAccuracy = accuracy;
         }
      }
   });
   return bestAttempt;
}

function addAssigneeToTask(task, student) {
   var data = { aid: task.aid, uids: [student.uid] };
   $.ajax({
      url: "/api/tasks/assign",
      type: "POST",
      contentType:false,
      processData: false,
      cache: false,
      dataType: "json",
      data: JSON.stringify(data),
      success: function(attempts) {
         var outof = task.numquestions ? task.numquestions : 0;
         $("#marksheet-student-"+student.uid+"-"+task.aid).html("<span>0/"+outof+"</span>").unbind('click').click(function(){
            returnTo = "marksheet";
            $("#tabs-taskmarksheet").hide();
            $("#tabs-tasklist").show();
            task.attempts[student.uid] = attempts[student.uid]; // adds this students new blank attempt to the task.
            loadStudentAttempts(task, student);
            return false;
         });
      },
      error: function(j) {
         dfmAlert("An error occurred when trying to assign this task aid="+task.aid+" uid="+student.uid+": <strong>"+j.responseText+"</strong>");
      }
   });
}

function unassignTask(aid, student) {
   var data = { aid, uids: [student.uid] };
   $.ajax({
      url: "/api/tasks/unassign",
      type: "POST",
      contentType:false,
      processData: false,
      cache: false,
      dataType: "json",
      data: JSON.stringify(data),
      success: function () {
         closeStudentAttempt(true)
      },
      error: function(j) {
         dfmAlert("An error occurred when trying to unassign this task: <strong>"+j.responseText+"</strong>");
      }
   });
}

// The flow for loading a task
// Arguments:
//   id:  either aid (task id) or aaid (task attempt id)
//   wasTaskId:  true if id was aid, false if aaid.
//   studentToUse:  If defined, the user we wish to to get the task attempts for.
// -- (a) If a student
// --    (i) If no attempts yet (just the 'empty' first attempt), start the start immediately.
// --    (ii) If semi-complete or multiple attempts, show attempts
// -- (b) If a teacher
// --    (i) If no studentToUse specified, load the 'task analysis' (i.e. with 'full breakdown', by topic and by question tabs)
// --    (ii) If studentToUse specified, show attempts.

function loadTask(id, wasTaskId, studentToUse) {
   console.log("[LoadTask] id="+id+" wasTaskId="+wasTaskId+" studentToUse="+JSON.stringify(studentToUse));
   if(!studentToUse && wasTaskId && !isStudent())return loadTaskAnalysis(id);
   var url = wasTaskId ? "/api/tasks/tasks?aid="+id+(studentToUse ? "&uid="+studentToUse.uid : "")
             : "/api/tasks/tasks?aaid="+id+(studentToUse ? "&uid="+studentToUse.uid : "")

   console.log(url);
   $.ajax({
      url: url,
      type: "GET",
      contentType:false,
      processData: false,
      cache: false,
      dataType: "json",
      success: function(task){
         $('body').data('task', task);
         console.log("Setting task to "+JSON.stringify(task));
         if(!wasTaskId) {
            studentToUse = task._user;
         }
         if(isStudent() && task.attempts.length==1 && task.attempts[0].numcompleted[0]==0) {
            window.location = 'do-question.php?aaid='+task.attempts[0].aaid;
         } else {
            loadStudentAttempts(task, studentToUse ? studentToUse : Context.user, wasTaskId ? null : id);
         }
      },
      error: function(j) {
         dfmAlert("An error occurred when trying to load the task aid="+id+": <strong>"+j.responseText+"</strong>");
      }
   });

}

function reloadTaskAnalysis() {
   var lastAid = $("#progress-tasklist-analysis").data('aid');
   $("#progress-tasklist-analysis-refresh").prop('disabled', true);
   loadTaskAnalysis(lastAid);
}

var returnTo;


function loadAnalysisByQuestion() {
   var aid = $("#progress-tasklist-analysis").data('aid');
   var sort = $("#analysis-byquestion-sort").val();
   $("#analysis-byquestion-questions").empty();
   $.ajax({
      url: "/api/tasks/worst/"+aid+"?sort="+sort,
      type: "GET",
      contentType:false,
      processData: false,
      cache: false,
      dataType: "json",
      success: function(questions){
         $.each(questions, function(qnum, question) {
            generateQuestionRowHTML(question, {}, $("#analysis-byquestion-questions"));
         });
         MathJax.typeset();

      },
      error: function(j) {
         dfmAlert("An error occurred when trying to load the worst question analysis aid="+aid+": <strong>"+j.responseText+"</strong>");
      }
   });

}

function loadTaskAnalysis(aid) {
   console.log("[LoadTaskAnalysis] aid="+aid);
   $("#progress-menu").dfmSideMenu("selectTab", "tabs-tasklist", true);
   $("#tabs-tasklist > div").hide();
   $("#progress-tasklist-analysis").show();
   $("#progress-tasklist-analysis-tabs").dfmTabs("selectTab", "analysis-full"); // defaults to 'Full Breakdown' tab.
   $("#analysis-full tbody").empty();
   $("#analysis-full thead").empty();
   $("#analysis-bytopic tbody").empty();
   $("#analysis-bytopic thead").empty();
   $("#progress-tasklist-analysis").data('aid', aid);
   $("#progress-tasklist-analysis-refresh").prop('disabled', false);
   $.ajax({
      url: "/api/tasks/analysis/"+aid,
      type: "GET",
      contentType:false,
      processData: false,
      cache: false,
      dataType: "json",
      success: function(analysis){

         console.log("WORKING: "+JSON.stringify(analysis.working));

         $("#progress-tasklist-analysis-header-titles h1").html(limitLength(analysis.task.text, 50));
         $("#progress-tasklist-analysis-header-titles h2").html(limitLength(analysis.task.settocache, 80));

         var head = $("#analysis-full thead");
         var body = $("#analysis-full tbody");
         var headByTopic = $("#analysis-bytopic thead");
         var bodyByTopic = $("#analysis-bytopic tbody");

         var isFixedTask = !!analysis.task.wid;
         var isExamMarking = analysis.task.cdata.accuracymeasure == 1;
         if(isFixedTask)$("#progress-tasklist-analysis-tabs li").eq(2).show();
         else $("#progress-tasklist-analysis-tabs li").eq(2).hide(); // hides 'By Question' tab if not a fixed task.
         head.append("<th></th>"); // names column.
         head.append("<th></th>"); // status column.
         headByTopic.append("<th></th>");

         // Full breakdown table headings.
         for(var i=1; i<=analysis.maxQNum; i++) {
            if(isFixedTask)head.append("<th class='qheading clickable' id='qheading-"+i+"'><h1>Q"+i+"</h1><a href='#'>View</a></th>");
            else head.append("<th class='qheading' id='qheading-"+i+"'><h1>Q"+i+"</h1></th>");
            $("#qheading-"+i).data('qnum', i);
            if(isFixedTask) {
               $("#qheading-"+i).click(function(){
                  var qnum = $(this).data('qnum');
                  displayTaskQuestion(aid, qnum);
                  return false;
               });
            }
         }

         // By topic table headings
         $.each(analysis.skills, function(k,skill) {
            headByTopic.append("<th>"+getSubskillLabel(skill)+"<br><small>"+(skill.correct ? Math.round(100*skill.correct)+"% correct" : "")+"</small></th>");
         });

         var recipients = {uids: []}; // this will be used later if 'edit task' button is clicked.
         $.each(analysis.uids, function(k,uid) {
            var student = analysis.students[uid];
            // Work out number of attempts.
            var numAttempts = 0;
            $.each(analysis.answers[student.uid], function(i,answersToEachQ) {
               if(answersToEachQ.length>numAttempts)numAttempts = answersToEachQ.length;
            });
            recipients.uids.push(student.uid);
            body.append("<tr id='analysis-student-"+student.uid+"'><td class='clickable'><span>"+student.surname+", "+student.firstname+"</span><a href='#'>View Attempts ("+numAttempts+")</a></td></tr>");
            bodyByTopic.append("<tr id='analysis-bytopic-student-"+student.uid+"'><td class='clickable'><span>"+student.surname+", "+student.firstname+"</span><a href='#'>View Attempts ("+numAttempts+")</a></td></tr>");
            var row = $("#analysis-student-"+student.uid);
            var rowByTopic = $("#analysis-bytopic-student-"+student.uid);
            var accuracyLabel = isExamMarking ? student.marks+"/"+analysis.task.maxmarks
                   : student.numcorrect+"/"+(analysis.task.numquestions ? analysis.task.numquestions : student.numcompleted);
            row.append("<td><div class='row-completion'></div></td>");
            const completeElement = student.complete
               ? $("<img alt='task completed icon' class='row-completion__completed-icon' src='/images/tick_icon.svg'>")
               : null;
            if (student.complete && student.earliestDateCompleted) {
               completeElement.attr('title', `Completed on ${dayjs(student.earliestDateCompleted * 1000).format('D MMM YYYY')}`);
            }
            const accuracyElement = $(`<span class="row-completion__text">${accuracyLabel}</span>`);
            const timeTakenElement = student.timetaken
               ? $(`<span class="row-completion__text">${formatTime(student.timetaken)}</span>`)
               : null;
            const lateElement = student.lateMark
               ? `<span class='row-completion__late'>
                     <img alt='late submission icon' class='row-completion__late-icon' src='/images/notification_late.svg'>
                     <span class="row-completion__text">Late</span>
                  </span>`
               : null;
            row.find('.row-completion').append(completeElement, accuracyElement, timeTakenElement, lateElement);

            row.data('student', student);
            rowByTopic.data('student', student);
            var viewAttemptsCell = row.children().first();
            viewAttemptsCell.click(function(){
               var student = row.data('student');
               returnTo = "analysis";
               loadTask(aid, true, student);
            });
            var viewAttemptsByTopicCell = rowByTopic.children().first();
            viewAttemptsByTopicCell.click(function(){
               var student = rowByTopic.data('student');
               returnTo = "analysis";
               loadTask(aid, true, student);
            });

            for(var i=1; i<=analysis.maxQNum; i++) {
               row.append("<td class='analysis-cell' id='analysis-student-"+student.uid+"-"+i+"'></td>");
               var cell = $("#analysis-student-"+student.uid+"-"+i);
               if(!analysis.answers[student.uid] || !analysis.answers[student.uid][i]) {
                  cell.addClass('unseen');
                  continue;
               }
               var answers = analysis.answers[student.uid][i];  // [{qnum: ..., iscorrect: bool|null }] - it's an array due to possible multiple attempts.
               var bestAnswer = undefined; // the most correct answer. true beats rendering error beats false beats undefined
               var wasACorrect = false;
               var wasAnIncorrect = false;
               $.each(answers, function(k,a) {
                  if(a.iscorrect===true && (!bestAnswer || bestAnswer.iscorrect!==true)) {
                     bestAnswer = a;
                  } else if(a.failedRendering && (!bestAnswer || bestAnswer.iscorrect!==true)) {
                     bestAnswer = a;
                  } else if(a.iscorrect===false && (!bestAnswer || (bestAnswer.iscorrect!==true && bestAnswer.iscorrect!==false))) {
                     bestAnswer = a;
                  } else if(!bestAnswer) {
                     bestAnswer = a;
                  }
                  if(a.iscorrect===true)wasACorrect = true;
                  if(a.iscorrect===false)wasAnIncorrect = true;
               });
               if(bestAnswer) {
                  if(isExamMarking) {
                     var label = "<span>"+bestAnswer.marksawarded+"/"+bestAnswer.marksoutof+"</span>";
                     if((wasACorrect && wasAnIncorrect) || (bestAnswer.marksawarded>0 && bestAnswer.marksawarded < bestAnswer.marksoutof))cell.addClass('eventuallycorrect').html(label);
                     else if(bestAnswer.failedRendering)cell.addClass('rendererror').html("-/-");
                     else if(bestAnswer.iscorrect===false)cell.addClass('incorrect').html(label);
                     else if(bestAnswer.iscorrect && bestAnswer.wasSecondTry)cell.addClass('secondtry').html(label);
                     else if(bestAnswer.iscorrect===true)cell.addClass('correct').html(label);
                     else cell.addClass('seen').html("").attr('title', 'Question seen but not answered');
                  } else {
                     if(wasACorrect && wasAnIncorrect)cell.addClass('eventuallycorrect').html("<span><img src='/images/tick_icon.svg'></span>").attr('title', 'Correct on a subsequent attempt of task');
                     else if(bestAnswer.failedRendering)cell.addClass('rendererror').html("<span><img src='/images/notification_late.svg'></span>").attr('title', 'The student could not attempt this question due to a website error');
                     else if(bestAnswer.iscorrect===false)cell.addClass('incorrect').html("<span><img src='/images/cross_icon.svg'></span>").attr('title', 'Incorrect');
                     else if(bestAnswer.iscorrect && bestAnswer.wasSecondTry)cell.addClass('secondtry').html("<span><img src='/images/tick_icon.svg'></span>").attr('title', 'Correct on second try');
                     else if(bestAnswer.iscorrect===true)cell.addClass('correct').html("<span><img src='/images/tick_icon.svg'></span>").attr('title', 'Correct on first try');

                     else cell.addClass('seen').html("").attr('title', 'Question seen but not answered');
                  }
                  if(analysis.working && analysis.working[student.uid] && $.inArray(i, analysis.working[student.uid])>=0) {
                     cell.find('span').addClass('hasworking');
                  }

                  // Make answer cell clickable.
                  bestAnswer.uid = student.uid;
                  cell.data('answer', bestAnswer);
                  cell.addClass('clickable').click(function(){
                     var answer = $(this).data('answer');
                     loadStudentAnswer(answer, analysis.task.cdata && analysis.task.cdata.accuracymeasure==1);
                     return false;
                  });
               } else {
                  cell.addClass('unseen');
               }

               // Is there written feedback associated with this question for this student?
               if(analysis.feedback[student.uid] && analysis.feedback[student.uid].indexOf(i)>=0) {
                  cell.addClass('withfeedback');
               }
            }

            $.each(analysis.skills, function(k2,skill) {
               var performance = skill.students ? skill.students[student.uid] : undefined;
               rowByTopic.append("<td id='analysis-bytopic-cell-"+student.uid+"-"+skill.id+"' class='analysis-bytopic-accuracy'></td>");
               var cell = $("#analysis-bytopic-cell-"+student.uid+"-"+skill.id);
               if(performance) {
                  cell.html(performance.numcorrect+"/"+performance.outof);
                  cell.css('background-color', getAccuracyColour(100*performance.numcorrect/performance.outof));
               }
            });


         });

         analysis.task.recipients = recipients;
         $('body').data('task', analysis.task); // used for exam by Edit Task button.

         // Makes the top header same width as table. This is to sort out problems with position:sticky.
         $("#progress-tasklist-analysis-headercontainer").outerWidth($("#analysis-full").outerWidth());

         // Wire up the delete task button.
         $("#progress-tasklist-analysis-delete").off("click").on("click", () => {
            deleteTask(aid, analysis.creator ?? null);
         })

         MathJax.typeset();

      },
      error: function(j) {
         dfmAlert("An error occurred when trying to load the task analysis aid="+aid+": <strong>"+j.responseText+"</strong>");
      }
   });

}

function loadStudentAnswer(answer, isExamMarking) {
   console.log("[LoadStudentAnswer] "+JSON.stringify(answer));
   $.ajax({
      url: "/api/tasks/useranswer/"+answer.aaid+"/"+answer.qnum,
      type: "GET",
      contentType:false,
      processData: false,
      cache: false,
      dataType: "json",
      success: function(data){
         console.log(JSON.stringify(data));
         dfmAlert("<div id='dialog-useranswer'></div>");
         $(".modal").css('max-width', '750px'); // makes the popup window more generous in width
         $(".modal").addClass('dialog-useranswer-container');
         generateQuestionRowHTML(data.question, data.useranswer, $("#dialog-useranswer"), isExamMarking);
         MathJax.typeset();
      },
      error: function(j) {
         dfmAlert("An error occurred when trying to load the task question: <strong>"+j.responseText+"</strong>");
      }
   });

}

function displayTaskQuestion(aid, qnum) {
   $.ajax({
      url: "/api/tasks/fixedquestion/"+aid+"/"+qnum,
      type: "GET",
      contentType:false,
      processData: false,
      cache: false,
      dataType: "json",
      success: function(question){
         dfmAlert("<div id='dialog-taskquestion'></div>");
         dfm_generateQuestionContent($("#dialog-taskquestion"), question, null, 1);
         $("#dialog-taskquestion input[type=submit]").prop('disabled', true);
         MathJax.typeset();
      },
      error: function(j) {
         dfmAlert("An error occurred when trying to load the task question="+aid+" qnum="+qnum+": <strong>"+j.responseText+"</strong>");
      }
   });
}

function reattemptTask(aid) {
   $.ajax({
      url: "/api/tasks/reattempt/" + aid,
      type: "POST",
      contentType: false,
      processData: false,
      cache: false,
      dataType: "json",
      success: function (aaid) {
         window.location = 'do-question.php?aaid=' + aaid;
      },
      error: function (j, textStatus, errorThrown) {
         dfmAlert("An error occurred when trying to reattempt the task aid=" + aid + ": <strong>" + j.responseText + "</strong>");
      }
   });
}

function loadStudentAttempts(task, student, initialAttemptId = null) {
   $("#tabs-tasklist > div").hide();
   $("#progress-tasklist-studentattempts").show();

   if(isTeacher() || isTrustAdmin()) {
      $("#progress-tasklist-studentattempts-header-titles h1").html(student.firstname+" "+student.surname);
      $("#progress-tasklist-studentattempts-header-titles h2").html(limitLength(task.text, 50));
   } else {
      $("#progress-tasklist-studentattempts-header-titles h1").html(limitLength(task.text, 50));
   }
   $("#progress-tasklist-studentattempts-header-list").empty();

   if(task.attempts[student.uid]) {
      for(var i=1; i<=Object.keys(task.attempts[student.uid]).length; i++) {
         $("#progress-tasklist-studentattempts-header-list").append("<option value='"+task.attempts[student.uid][i-1].aaid+"'>Attempt "+i+"/"+task.attempts[student.uid].length+"</option>");
      }
   }
   if (initialAttemptId) {
      $("#progress-tasklist-studentattempts-header-list").val(initialAttemptId);
   } else {
      $("#progress-tasklist-studentattempts-header-list option").last().prop('selected', true);
   }
   $("#progress-tasklist-studentattempts-header-list").unbind('change').change(function(){
      loadStudentIndividualAttempt($(this).val());
   }).change();
}

function closeStudentAttempt(reload) {
   $("#tabs-tasklist > div").hide();
   $("#progress-tasklist-studentattempts-questions").empty(); // prevents problems of there being multiple copies of a question row.
   var task = $('body').data('task');

   if(returnTo=="analysis") {
      $("#progress-tasklist-analysis").show();
      if(reload)loadTaskAnalysis(task.aid);
   }
   else if(returnTo=="activitylog") {
      $("#tabs-tasklist").hide();
      $("#tabs-studentprogress").show();
      if(reload)loadActivityLog();
   }
   else if(returnTo=="marksheet") {
      $("#tabs-tasklist").hide();
      $("#tabs-taskmarksheet").show();
      if(reload)loadMarksheet();
   }
   else if (returnTo === "feedback") {
      $("#tabs-tasklist").hide();
      $("#tabs-feedback").show();
      $("#progress-menu").dfmSideMenu("selectTab", "tabs-feedback", true);
   }
   else {
      $("#progress-tasklist-home").show();
      loadTaskList();
   }
   returnTo = undefined;
}

function closeTaskAnalysis() {
   if(returnTo=="marksheet") {
      $("#tabs-tasklist").hide();
      $("#tabs-taskmarksheet").show();
   } else if (returnTo === "feedback") {
      $("#tabs-tasklist").hide();
      $("#tabs-feedback").show();
      $("#progress-menu").dfmSideMenu("selectTab", "tabs-feedback", true);
   } else {
      // Task list
      $("#tabs-tasklist > div").hide();
      $("#progress-tasklist-home").show();
      loadTaskList();
   }
   returnTo = undefined;
}

// FEEDBACK UI

// Specific elements.
const feedbackEmptyMessage = $("#feedback-empty-message");
const feedbackLoading = $("#feedback-loading");
const feedbackRefreshButton = $("#feedback-refresh-button");
const feedbackBackButton = $("#feedback-back-button");
const feedbackMarkAllAsReadButton = $("#feedback-mark-all-as-read-button");
const feedbackAllButton = $("#feedback-all-button");
const feedbackUnreadButton = $("#feedback-unread-button");
const feedbackQuestionList = $("#feedback-question-list");
const feedbackQuestionContainer = $("#feedback-question-container");

// Pagination elements (header and footer).
const feedbackPaginationContainers = $(".feedback__pagination");
const feedbackPaginationLabels = $(".feedback__pagination__label");
const feedbackPaginationPreviousButtons = $(".feedback__pagination__previous");
const feedbackPaginationNextButtons = $(".feedback__pagination__next");

// Feedback list state.
let feedbackListLimit = 10;
let feedbackListOffset = 0;
let feedbackUnreadOnly = false;

/**
 * Used to disabled all buttons in the feedback UI
 * while awaiting an asynchronous operation.
 */
function disableFeedbackUI() {
   feedbackRefreshButton.prop("disabled", true);
   feedbackMarkAllAsReadButton.prop("disabled", true);
   feedbackBackButton.prop("disabled", true);
   feedbackUnreadButton.prop("disabled", true);
   feedbackAllButton.prop("disabled", true);
   feedbackPaginationPreviousButtons.prop("disabled", true);
   feedbackPaginationNextButtons.prop("disabled", true);
}

/**
 * Renders the refresh button with click event handler.
 */
function renderFeedbackRefreshButton() {
   feedbackRefreshButton.off("click").on("click", () => {
      disableFeedbackUI();
      feedbackListOffset = 0;
      loadAndRenderFeedbackListView();
   });
   feedbackRefreshButton.prop("disabled", false);
   feedbackRefreshButton.show();
}

/**
 * Renders the "Mark all as read" button with click
 * event handler.
 */
function renderFeedbackMarkAllAsReadButton() {
   const markAllAsRead = async () => {
      disableFeedbackUI();
      const loadingMessageTimeout = setTimeout(() => {
         feedbackLoading.show()
      }, 200);
      await markAllFeedbackAsRead();
      clearTimeout(loadingMessageTimeout);
      loadAndRenderFeedbackListView();
   }
   feedbackMarkAllAsReadButton.off("click").on("click", () => {
      dfmConfirm(
         "<h3>Mark all as read</h3>" +
         "<p>This action will mark all of your feedback messages as read and cannot be undone.</p>" +
         "<p>Are you sure you want to continue?</p>",
         markAllAsRead
      );
   });
   feedbackMarkAllAsReadButton.prop("disabled", false);
   feedbackMarkAllAsReadButton.show();
}

/**
 * Renders the two buttons that act as a toggle for the
 * status of the feedback list (all or unread), with
 * click event handlers.
 */
function renderFeedbackStatusToggleButtons() {
   feedbackAllButton.add(feedbackUnreadButton).off("click").on("click", () => {
      disableFeedbackUI();
      feedbackListOffset = 0;
      feedbackUnreadOnly = !feedbackUnreadOnly;
      feedbackAllButton.toggleClass("active", !feedbackUnreadOnly);
      feedbackUnreadButton.toggleClass("active", feedbackUnreadOnly);
      loadAndRenderFeedbackListView();
   });
   feedbackAllButton.prop("disabled", false);
   feedbackAllButton.show();
   feedbackUnreadButton.prop("disabled", false);
   feedbackUnreadButton.show();
}

/**
 * Renders the relevant label and buttons for the pagination
 * of results, according to the total number of results.
 *
 * @param {number} totalResults
 */
function renderFeedbackPagination(totalResults) {
   const updatePaginationUI = () => {
      feedbackPaginationLabels.text(
        `${feedbackListOffset + 1}–${Math.min(feedbackListOffset + feedbackListLimit, totalResults)} of ${totalResults}`,
      );
      feedbackPaginationLabels.show();
      feedbackPaginationPreviousButtons.prop("disabled", feedbackListOffset === 0);
      feedbackPaginationNextButtons.prop("disabled", feedbackListOffset + feedbackListLimit >= totalResults);
   }
   feedbackPaginationPreviousButtons.off("click").on("click", () => {
      feedbackRefreshButton.prop("disabled", true);
      feedbackListOffset -= feedbackListLimit;
      updatePaginationUI();
      window.scrollTo({ top: 0, behavior: "smooth" });
      loadAndRenderFeedbackListView();
   });
   feedbackPaginationNextButtons.off("click").on("click", () => {
      feedbackRefreshButton.prop("disabled", true);
      feedbackListOffset += feedbackListLimit;
      updatePaginationUI();
      window.scrollTo({ top: 0, behavior: "smooth" });
      loadAndRenderFeedbackListView();
   });
   updatePaginationUI();
   feedbackPaginationContainers.toggle(totalResults > 0);
}

/**
 * Renders the back button with click event handler.
 */
function renderFeedbackBackButton() {
   feedbackBackButton.off("click").on("click", () => {
      disableFeedbackUI();
      loadAndRenderFeedbackListView();
   });
   feedbackBackButton.prop("disabled", false);
   feedbackBackButton.show();
}

/**
 * Renders the list of questions with feedback. Each question can
 * be clicked to view the feedback for that question.
 *
 * @param {import("~/utils/tasks").QuestionWithFeedback[]} questionsWithFeedback
 */
async function renderFeedbackList(questionsWithFeedback = []) {
   feedbackQuestionList.empty();
   questionsWithFeedback.forEach((result, i) => {
      // Extract the data from the result.
      const {
         attemptId,
         attemptUserUid,
         attemptUserDisplayName = "",
         questionNumber,
         hasUnreadMessages,
         latestMessage = "",
         latestMessageTimestamp,
         latestMessageSenderUid,
         latestMessageSenderDisplayName = "",
         taskLabel = "",
         taskSetTimestamp,
         taskType,
      } = result;

      // Formulate a compact string for the date
      const dateString = typeof latestMessageTimestamp === "number"
         ? formatRelativeDateTime(latestMessageTimestamp * 1000)
         : "Unknown date";

      // Format the message to display, limiting to 50 characters.
      const parsedMessage = typeof latestMessage === "string"
         ? limitLength(replaceMathsTags(latestMessage).replaceAll("\n", " "), 50)
         : "No message";
      const messagePrefix = latestMessageSenderUid === Context.user?.uid
         ? "You: "
         : latestMessageSenderUid === attemptUserUid
         ? ""
         : `${latestMessageSenderDisplayName}: `;
      const messageToDisplay = `${messagePrefix}${parsedMessage}`;

      /**
       * Determine a description for the task.
       *
       * Independent practice and clean up tasks are labelled differently.
       * Otherwise, use the task label (if it exists).
       */
      const taskIsIndependent = ["p", "c", "kc"].includes(taskType);
      const taskIsCleanUp = taskType === "z";
      let taskDescription = "";
      const setDateString = typeof taskSetTimestamp === "number"
         ? dayjs(taskSetTimestamp * 1000).format("D MMM")
         : "Unknown date";
      if (taskIsIndependent) {
         taskDescription = `Independent Practice (${setDateString})`;
      } else if (taskIsCleanUp) {
         taskDescription = `Clean Up Task (${setDateString})`;
      } else if (taskLabel) {
         taskDescription = limitLength(taskLabel, 100);
      } else {
         taskDescription = `Unlabelled Task (${setDateString})`;
      }

      // Create the question row.
      const questionRow = $(`
         <div id="feedback-${attemptId}-${questionNumber}" class="feedback__questions__item ${hasUnreadMessages ? "" : "read"} ${i === 0 ? "first" : ""}">
            <div class="feedback__questions__item__summary">
               <span class="feedback__questions__item__summary__display-name">${attemptUserDisplayName.toLowerCase()}</span>
               <span class="feedback__questions__item__summary__task">Question ${questionNumber} of ${taskDescription}</span>
               <span class="feedback__questions__item__summary__latest">
                  ${hasUnreadMessages ? "<span class='feedback__questions__item__summary__latest__unread-dot'></span>" : ""}
                  <span class="feedback__questions__item__summary__latest__message">${messageToDisplay}</span>
               </span>
            </div>
            <div class="feedback__questions__item__date">${dateString}</div>
         </div>
      `);

      // Wire up the question row to load the feedback for this question.
      questionRow.on("click", () => {
         disableFeedbackUI();
         loadAndRenderFeedbackQuestionView({ ...result, taskLabel: taskDescription });
      });

      // Append the question row to the list.
      feedbackQuestionList.append(questionRow);
   });
   feedbackEmptyMessage.toggle(questionsWithFeedback.length === 0);
   feedbackQuestionList.toggle(questionsWithFeedback.length > 0);
}

/**
 * Loads the relevant data and renders the list view of the feedback panel.
 */
async function loadAndRenderFeedbackListView() {
   // Show a loading message if the data takes a while to load.
   const loadingMessageTimeout = setTimeout(() => {
      feedbackLoading.show()
   }, 200);

   // Load the data according to the current offset and limit.
   const offsetSent = feedbackListOffset;
   const data = await getLatestFeedbackByQuestion({
      limit: feedbackListLimit,
      offset: feedbackListOffset,
      status: feedbackUnreadOnly ? "unread" : "all",
   }) ?? {};
   const { totalResults, results = [] } = data;

   // Discard results if offset has changed since the request was made.
   if (offsetSent !== feedbackListOffset) {
      return;
   }

   // Render the feedback list.
   renderFeedbackList(results);

   // Render all other relevant parts of the UI.
   renderFeedbackRefreshButton();
   renderFeedbackMarkAllAsReadButton();
   renderFeedbackStatusToggleButtons();
   renderFeedbackPagination(totalResults);

   // Hide the container for the question view and the back button.
   feedbackQuestionContainer.hide();
   feedbackBackButton.hide();

   // Prevent or hide the loading message.
   clearTimeout(loadingMessageTimeout);
   feedbackLoading.hide();

   // Render MathJax.
   MathJax.typeset();
}

/**
 * Loads the relevant data and renders the question view of the feedback panel.
 *
 * @param {import("~/utils/tasks").QuestionWithFeedback} questionWithFeedback
 */
async function loadAndRenderFeedbackQuestionView({
   attemptId,
   attemptUserDisplayName = "",
   questionNumber,
   hasUnreadMessages,
   taskId,
   taskLabel = ""
}) {
   // Show a loading message if the data takes a while to load.
   const loadingMessageTimeout = setTimeout(() => {
      feedbackLoading.show()
   }, 200);

   // Load the data for the selected question feedback.
   const data = await getUserAnswer(attemptId, questionNumber) ?? {};
   const { question, useranswer: userAnswer } = data;
   if (question && userAnswer) {
      // Empty the feedback question container.
      feedbackQuestionContainer.empty();

      // Render the question and answer content, along with all feedback for this question.
      generateQuestionRowHTML(question, userAnswer, feedbackQuestionContainer);

      // Send request to mark the feedback as read. No need to wait for it to complete.
      if (hasUnreadMessages) {
         markFeedbackAsRead(attemptId, questionNumber);
      }

      // A few display adjustments to the product of generateQuestionRowHTML.
      feedbackQuestionContainer.children(".studentattempt-question").css("margin", 0).css("border-radius", 0);
      feedbackQuestionContainer.find(".student-question-feedback").addClass("large");

      /**
       * This element being removed will prevent users from being able to update
       * the "correctness" of the question. This functionality would require an
       * isExamMarking flag to be passed to generateQuestionRowHTML and it's not
       * currently obvious how we can do this without an additional API request.
       *
       * TODO:    Determine if this functionality is worth the additional steps
       *          to implement.
       */
      feedbackQuestionContainer.find(".studentattempt-iscorrect").remove();

      // Render a header for the feedback question.
      const feedbackQuestionHeader = $(`
         <div class="feedback__question__header">
            <h2 class="feedback__question__header__name">${attemptUserDisplayName.toLowerCase()}</h2>
            <a class="feedback__question__link" href="/progress.php?aid=${taskId}">${taskLabel}</a>
         </div>
      `);
      feedbackQuestionContainer.prepend(feedbackQuestionHeader);
      feedbackQuestionHeader.children(".feedback__question__link").on("click", (e) => {
         e.preventDefault();
         returnTo = "feedback";
         loadTask(taskId, true);
      });

      // Render a footer for the feedback question.
      const feedbackQuestionFooter = $(`
         <div class="feedback__question__footer">
            <a class="feedback__question__link" href="/progress.php?aaid=${attemptId}">View full attempt</a>
         </div>
      `);
      feedbackQuestionContainer.append(feedbackQuestionFooter);
      feedbackQuestionFooter.children(".feedback__question__link").on("click", (e) => {
         e.preventDefault();
         returnTo = "feedback";
         loadTask(attemptId, false);
      });

      // Show the question container.
      feedbackQuestionContainer.show();

      // Render the back button.
      renderFeedbackBackButton();

      // Hide the question list.
      feedbackQuestionList.hide();

      // Hide the other parts of the feedback header.
      feedbackRefreshButton.hide();
      feedbackMarkAllAsReadButton.hide();
      feedbackPaginationContainers.hide();
      feedbackAllButton.hide();
      feedbackUnreadButton.hide();

      // Render MathJax.
      MathJax.typeset();
   }

   // Prevent or hide the loading message.
   clearTimeout(loadingMessageTimeout);
   feedbackLoading.hide();
}

function loadFeedbackPane()
{
   $("#progress-tasklist-studentattempts-questions").empty(); // prevents questions appearing in two panes and causing problems
   loadAndRenderFeedbackListView();
}

function loadStudentIndividualAttempt(aaid) {
   $("#progress-menu").dfmSideMenu("selectTab", "tabs-tasklist", true);
   $("#tabs-tasklist > div").hide();
   $("#progress-tasklist-studentattempts").show();
   console.log("[LoadingStudentIndividualAttempt] aaid=" + aaid);
   var url = "/api/tasks/attempt/" + aaid;

   $("#progress-tasklist-studentattempts-questions").empty();
   $("#progress-tasklist-studentattempts-header-button").hide();
   $.ajax({
      url: url,
      type: "GET",
      contentType: false,
      processData: false,
      cache: false,
      dataType: "json",
      success: function (attempt) {
         var task = $('body').data('task');
         console.log(JSON.stringify(attempt));
         $.each(attempt._questions, function (qnum, question) {
            var userAnswer = attempt.answers[qnum];
            generateQuestionRowHTML(question, userAnswer, $("#progress-tasklist-studentattempts-questions"), task && task.cdata && task.cdata.accuracymeasure == 1);
         });

         // Deal with continue/reattempt button.
         // The last scenario (i.e. non-started attempt) wouldn't usually be accessible, as the user should have already been automatically forwarded to the task.
         $("#progress-tasklist-studentattempts-header-button").unbind('click');

         if (isStudent() && attempt.complete && task.cdata && task.cdata.preventreattempts === false) {
            $("#progress-tasklist-studentattempts-header-button").show().html("Re-attempt Task").click(function () {
               reattemptTask(attempt.aid);
            });
         } else if (!isStudent()) {
            $("#progress-tasklist-studentattempts-header-button").show().html("Un-assign Task").click(function () {
               unassignTask(attempt.aid, {uid: attempt.uid});
            });
            setupMarkAsCompleteButton(attempt);
         } else if (attempt.complete) $("#progress-tasklist-studentattempts-header-button").hide();
         else if (Object.keys(attempt.answers).length > 0) $("#progress-tasklist-studentattempts-header-button").show().html("Continue Attempt").click(function () {
            window.location = 'do-question.php?aaid=' + attempt.aaid;
         });
         else {
            $("#progress-tasklist-studentattempts-questions").show().html("<p id='starttask-message'>Use the <strong>Start Attempt</strong> button above to start this task.</p>");
            $("#progress-tasklist-studentattempts-header-button").show().html("Start Attempt").click(function () {
               requireVideoDialog({
                  requiredSsids: task.cdata.videos,
                  allSubskills: task.wid ? task._worksheet._subskills : task.subskills,
                  task,
                  attempt
               });
            });
         }

         MathJax.typeset();

         if (typeof task === "object" && typeof attempt === "object") {
            /**
             * PostHog event for a user clicking a link to start or continue an attempt for a
             * task that has been assigned to them by another user.
             *
             * We want to fire this PostHog event under the following conditions:
             *  - The posthogFrom variable is set (so the event can be assigned a trigger ID).
             *  - The user is viewing their own attempt.
             *  - The user is not the task creator.
             */
            const userIsViewingOwnAttempt = attempt.uid && Context.user?.uid === attempt.uid;
            const userIsTaskCreator = task.creatorid && Context.user?.uid === task.creatorid;
            if (!posthogFrom || !userIsViewingOwnAttempt || userIsTaskCreator) {
               return;
            }

            // Map the posthogFrom variable to the relevant trigger ID.
            const posthogTriggerId = {
               "notification-task-set": "dashboard-task-set-notification",
               "notification-late": "dashboard-task-late-notification",
               "notification-reattempt": "dashboard-task-reattempt-notification",
               "notification-continue": "dashboard-task-continue-notification",
               "dashboard-task-list": "dashboard-my-homework-task-link",
               "progress-task-list": "progress-assigned-tasks-task-link",
               "task-set-email": "task-set-email-link",
               "task-reminder-email": "task-reminder-email-link",
               "task-reattempt-email": "task-reattempt-email-link",
            }[posthogFrom];

            if (!posthogTriggerId) {
               return;
            }

            posthogEventTaskSetWorkLinkClicked({
               triggerId: posthogTriggerId,
               task,
               attempt,
            });
         }
      },
      error: function (j, textStatus, errorThrown) {
         dfmAlert("An error occurred when trying to load the task attempt aaid=" + aaid + ": <strong>" + j.responseText + "</strong>");
      }
   });
}

/**
 * @param {Object} options
 * @param {number[]} options.requiredSsids
 * @param {Object[]} options.allSubskills
 * @param {Object} options.task
 * @param {Object} options.attempt
 */
function requireVideoDialog(options) {

   const {
      requiredSsids = [],
      allSubskills = [],
      task = {},
      attempt = {}
   } = options ?? {}

   const { aaid } = attempt;

   dfmDialog("<h2 id='requireviddialog-title'></h2><ul id='video-dialog-list'></ul>", [{label: "Start", action: function(){
      window.location = 'do-question.php?aaid='+aaid;
   }}], true);
   $.each(allSubskills, function(k,subskill) {
      if(subskill.video) {
         $("#video-dialog-list").append("<li id='requireviddialog-vid"+subskill.ssid+"'><a href='#'><span class='video-dialog-status'><span></span><label></label></span><img src='/images/video_icon.svg'><label>"+getSubskillFullName(subskill)+"<br><small>"+formatVideoLength(subskill.videolength)+"</small></label></a></li>");
         $("#requireviddialog-vid"+subskill.ssid).data('subskill', subskill).click(function(){
            var subskill = $(this).data('subskill');
            $.modal.close();
            openVideo({
               subskill,
               closeCallback: () => requireVideoDialog(options),
               posthogTriggerId: "progress-suggested-videos-modal-video-link",
               associatedTask: task,
               associatedAttempt: attempt,
            });
         });
      }
   });

   // If no videos available for these skills, need to start task immediately.
   if($("#video-dialog-list li").length==0) {
      window.location = 'do-question.php?aaid='+aaid;
   }
   $(".dialog-buttons button").addClass('final-start-button'); // easier to reference late and avoids confusion with buttons in other dialogs.
   $(".final-start-button").prop('disabled', true);
   updateRequiredVideoWatchStatus(requiredSsids, aaid);
}

function updateRequiredVideoWatchStatus(requiredSsids, aaid) {
   $.ajax({
      url: "/api/tasks/videosessions/" + aaid,
      type: "GET",
      contentType:false,
      processData: false,
      cache: false,
      dataType: "json",
      success: function(data){
         $("#video-dialog-list li").removeClass('watched').removeClass('required');
         let vidsWatched = [];

         $.each(data.videoSessions, function (k, vs) {
            if (vs.finished) {
               vidsWatched.push(vs.ssid);
            }
         });
         $.each(requiredSsids, function (k, ssid) {
            $("#requireviddialog-vid" + ssid).addClass($.inArray(ssid, vidsWatched) >= 0 ? 'watched' : 'required');
         });
         $.each(vidsWatched, function (k, ssid) {
            if ($.inArray(ssid, requiredSsids) === -1) {
               $("#requireviddialog-vid" + ssid).addClass('watched'); // Also mark non-required videos as watched.
            }
         });

         let ready = $("#video-dialog-list .required").length == 0;
         $(".final-start-button").prop('disabled', !ready);
         $("#requireviddialog-title").html(ready ? "You're ready to go! Consider watching these videos before starting." : "You're required to watch these videos before starting.");
      },
      error: function(){
         console.log("Error getting student video sessions. Making task startable anyway.");
         $(".final-start-button").prop('disabled', false);
      }
   });

   MathJax.typeset();
}

function setupMarkAsCompleteButton(attempt) {
   $("#progress-tasklist-studentattempts-header-markcompletebutton").show().unbind('click').click(function(){
      markAsCompleteOrIncomplete(attempt);
   });
   $("#progress-tasklist-studentattempts-header-markcompletebutton").html(attempt.complete ? "Mark as Incomplete" : "Mark as Complete");
   $("#progress-tasklist-studentattempts-header-makestudentredo").show().unbind('click').click(function() {
      makeStudentRedo(attempt.aid, attempt.uid);
   });
}

function markAsCompleteOrIncomplete(attempt) {
   var complete = attempt.complete;
   var data = {
      aaid: attempt.aaid,
      complete: !complete
   };
   $.ajax({
      url: "/api/tasks/forcemarkascomplete",
      type: "POST",
      contentType:false,
      processData: false,
      cache: false,
      dataType: "json",
      data: JSON.stringify(data),
      success: function(res){
         attempt.complete = res.complete;
         setupMarkAsCompleteButton(attempt);
      },
      error: function(j) {
         dfmAlert("An error occurred when trying to mark as "+(complete ? 'incomplete' : 'complete')+":<strong>"+j.responseText+"</strong>");
      }
   });

}


function generateQuestionRowHTML(question, userAnswer, dom, isExamMarking) {
   console.log("[GeneratingAttemptRow] "+JSON.stringify(userAnswer));

   let skillHTML = (question.subskill && question.subskill.ssid ? getSubskillFullName(question.subskill) + " <a href='explorer.php?ssid=" + question.subskill.ssid + "'>Review</a>" : "");
   let timeTakenHTML = userAnswer.timetaken ? formatTime(userAnswer.timetaken) : "";

   // If we're viewing 'worst answered questions' for a task, userAnswer will be blank, but the question will have qnum set.
   let qnum = userAnswer.qnum ? userAnswer.qnum : question.qnum;
   let domId = userAnswer.aaid ? "studentattempt-" + userAnswer.aaid + "-" + qnum : "taskquestion-" + qnum;

   /**
     * Set the context of this question row component - Student Attempt or By Question Analysis?
     * The studentanswers property is only set on the question object in context of By Question Analysis.
     * This property will always be a non-empty array due to how the question object is structured in TaskWorstAnswered::get.
     */
   var isByQuestionAnalysis = !!question.studentanswers && Array.isArray(question.studentanswers);

   let overwritable = !isStudent() && userAnswer && userAnswer.failedRendering === false;

   let copyFeedbackHTML = (!isStudent() && !userAnswer.iscorrect && !isByQuestionAnalysis) ?
      "<label style='margin-bottom:10px;display:inline-block'><input type='checkbox' id='copyfeedback'> Use feedback for all who got this question wrong.</label><br>"
      : "";

   let reportErrorFragment = question.qid ? "<h5><a href='#' class='report-error'>Report Error</a></h5>" : "";

   const feedbackLimit = isStudent() ? 500 : 5000;

   dom.append("<div id='"+domId+"' class='studentattempt-question'>"
    +"<div class='studentattempt-question-info'><h1>Question "+qnum+" "+(overwritable ? "<a title='Overwrite' class='studentattempt-iscorrect"+(isExamMarking ? " studentattempt-iscorrect-marks" : "")+"' href='#'></a>" : "<span class='studentattempt-iscorrect'></span>")+"</h1>"
        +"<h2>"+timeTakenHTML+"</h2>"
        +"<h3>"+skillHTML+"</h3>"
        + (
            // Do not show the whole answer block if the question failed to render for the student.
            (userAnswer && userAnswer.failedRendering === true) ? "" :
            (question.answer && question.answer.correctAnswer ? "<div><h4>Correct Answer:</h4>"
               + (question.response ? "<h5 class='student-question-markscheme'><a href='#'>See full markscheme</a></h5>" : "")
               + "<p class='student-question-correctanswer'></p></div>" : "")
            + (userAnswer.theiranswer ? "<div><h4>Student Answer:</h4>" + reportErrorFragment + "<p class='student-question-useranswer'></p></div>" : "")
            + (question.studentanswers ? "<div><h4>Student Answers:</h4>" + reportErrorFragment + "<ul class='student-question-useranswers'></ul></div>" : "")
            + (userAnswer.working ? "<div><h4>Working</h4><canvas width='250' style='margin-top:10px' class='working'></canvas></div>" : "")
         )
    +"</div>"
    +"<div class='studentattempt-question-main'>"
         +"<div class='student-question-content'></div>"
         +"<div class='student-question-feedback'><ul></ul><div class='feedback-addlink'><a href='#'>Write a new comment</a></div>"
                 +"<div class='feedback-add-row feedback-row' style='display:none'>"
                     +"<div class='feedback-image'><img src='/images/speech2_icon.svg'></div>"
                     +"<div class='feedback-label'><h2>"+getPublicName(Context.user)+"</h2></div>"
                     +"<div class='feedback-comment'>"
                     +"<textarea placeholder='Write your feedback here. For maths text, press Alt+Equals.'></textarea>"
                     +"<p class='feedback-limit-warning' style='color: red; display: none; font-size: 12px; margin-bottom: 0; margin-top: 4px;'>Feedback is limited to a maximum length of " + feedbackLimit + " characters.</p>"
                     +"<br>"+copyFeedbackHTML+"<button class='feedback-submit-button'>Submit</button></div>"
                 +"</div>"
         +"</div>"
    +"</div>");

   // Control visibility and text value of add feedback link in context of By Question Analysis.
   if (isByQuestionAnalysis) {
      var incorrectAnswers = question.studentanswers.filter(answer => !answer.iscorrect);
      // Do not show add feedback link if there are no incorrect answers.
      if (!incorrectAnswers.length) {
         $("#"+domId).find('.feedback-addlink').hide();
      } else {
         //If there are some incorrect answers, change link text and textarea placeholder.
         $("#"+domId).find('.feedback-addlink > a').text('Send feedback for incorrect answers');
         $("#"+domId).find('.feedback-comment > textarea').attr('placeholder','Write your feedback here for all students who answered incorrectly. For maths text, press Alt+Equals.');

      }
   }

   $("#"+domId).find('.feedback-addlink').click(function(){
      $("#"+domId).find('.feedback-addlink').hide();
      $("#"+domId).find('.feedback-add-row').show();
      return false;
   });
   $("#"+domId).find('.report-error').click(function(){
      reportQuestionError(question.qid, userAnswer.aaid, qnum);
   });
   $("#"+domId).find('textarea').dfmInputWithInsertableMaths();

   // Handle feedback character limit.
   $("#"+domId).find('textarea').on("input", function(e) {
      const feedbackLimitExceeded =  e.target.value.length > feedbackLimit

      // Add a border and outline to the text area if the limit is exceeded.
      $(this).css("border-color", feedbackLimitExceeded ? "red" : "").css("outline-color", feedbackLimitExceeded ? "red" : "");

      // Show the feedback limit warning if the limit is exceeded.
      $("#"+domId).find('.feedback-limit-warning').toggle(feedbackLimitExceeded);

      // Disable the send button if the limit is exceeded.
      $("#"+domId).find('.feedback-submit-button').attr('disabled', feedbackLimitExceeded).css('opacity', feedbackLimitExceeded ? 0.5 : 1);
   });

   $("#"+domId).find('.feedback-submit-button').on("click", function(){
      submitQuestionFeedback($("#"+domId), isByQuestionAnalysis);
   });
   if(userAnswer.working) {
      $("#"+domId).find('.working').dfmWhiteboard({
         admin: false, control: false, resize: false, master: false, teacher: false, fixTextSize: true, core: userAnswer.working, uncompress: true, crop: true
      });
   }

   if(userAnswer._feedback) {
      $.each(userAnswer._feedback, function(i, feedback) {
         addFeedbackRow($("#"+domId), feedback);
      });
   }

    // Attach an aaid and the qnum for submitQuestionFeedback use with By Question feedback context
   if (isByQuestionAnalysis) {
      // Select the aaid for one student attempt from all student answers to this question
      userAnswer.aaid = question.studentanswers[0].aaid
      userAnswer.qnum = qnum;
   }

   var rowDOM = $("#"+domId);
   rowDOM.data("userAnswer", userAnswer);

   // Correct/incorrect indicator.
   if(!isExamMarking) {
      if(userAnswer.iscorrect===true) {
         if(!isExamMarking) {
            rowDOM.find('.studentattempt-iscorrect').html("<img src='/images/tick_icon.svg'>");
            rowDOM.addClass('indicator-correct');
         } else {
         }
      } else if(userAnswer.failedRendering === true) {
         rowDOM.find('.studentattempt-iscorrect').html("<img src='/images/notification_late.svg'>");
         rowDOM.addClass('indicator-rendererror');
      } else if(userAnswer.iscorrect===false) {
         rowDOM.find('.studentattempt-iscorrect').html("<img src='/images/cross_icon.svg'>");
         rowDOM.addClass('indicator-incorrect');
      } else if(question.avgscore) {
         rowDOM.css('border-left', '5px solid '+getAccuracyColour(100*question.avgscore));
      } else {
         rowDOM.find('.studentattempt-iscorrect').html("");
         rowDOM.addClass('indicator-seen');
      }

   } else {
      if(userAnswer.iscorrect==undefined) {
         rowDOM.find('.studentattempt-iscorrect').html("");
         rowDOM.addClass('indicator-seen');
      } else {
         var marks = userAnswer.marksawarded ? userAnswer.marksawarded : (userAnswer.iscorrect===true ? question.marks : 0);
         rowDOM.find('.studentattempt-iscorrect').html(marks+"/"+question.marks);
         if(marks == question.marks)rowDOM.addClass('indicator-correct');
         else if(marks == 0)rowDOM.addClass('indicator-incorrect');
         else rowDOM.addClass('indicator-partialmarks');
      }
   }
   if(overwritable) {
      rowDOM.find('.studentattempt-iscorrect').click(function(){
         overwriteMarkDialog(question, userAnswer, isExamMarking);
         return false;
      });
   }

   // Correct answer and student answer
   if (question.answer && question.answer.correctAnswer) {
      insertHTMLAnswer(rowDOM.find(".student-question-correctanswer"), question, question.answer.correctAnswer, false);
   }
   if (userAnswer.theiranswer) {
      insertHTMLAnswer(rowDOM.find(".student-question-useranswer"), question, userAnswer.theiranswer, true);
   }
   if (question.studentanswers) {
      // This is for a task analysis 'by question'.
      $.each(question.studentanswers, function (k, answer) {
         var ul = rowDOM.find(".student-question-useranswers");
         ul.append("<li class='answer-" + k + "'><label><img src='/images/" + (answer.iscorrect ? "tick" : "cross") + "_icon.svg'>" + Math.round(100 * answer.count / question.numattempts) + "%</label><span></span></li>");
         insertHTMLAnswer(rowDOM.find(".answer-" + k + " span"), question, answer.answer, true);
         rowDOM.find(".answer-" + k).addClass(answer.iscorrect ? "correct" : "incorrect");
      });
   }

   // Markscheme
   rowDOM.find(".student-question-markscheme a").click(function(){
      dfmAlert(replaceMathsTags(question.response));
      MathJax.typeset();
      return false;
   });

   // Generate the question.
   if (userAnswer.failedRendering) {
      // Don't actually render the question, as this isn't representative of what the student saw.  Instead, render
      // a message stating that the student couldn't attempt the question.
      $("#"+domId+" .student-question-content").html("<p>The student could not attempt this question due to a website error.</p>");
   }
   else {
      dfm_generateQuestionContent($("#" + domId + " .student-question-content"), question, null, 0, userAnswer.theiranswer);
   }

}

// Adds the HTML for a feedback row.
// dom: The DOM element representing the whole task attempt question row.
// feedback: JSON representing the piece of feedback.

function addFeedbackRow(dom, feedback) {
   console.log("[AddingFeedbackRow] "+JSON.stringify(feedback));
   dom.find(".student-question-feedback ul").append("<li id='feedback-"+feedback.feid+"'>"
      +"<div class='feedback-image'><img src='/images/speech2_icon.svg'></div>"
      +"<div class='feedback-label'><h2>"+feedback.fromname+"</h2><h3>"+readFriendlyDate(feedback.d, true)+"</h3></div>"
      +"<div class='feedback-comment'><a class='feedback-delete' href='#'>&times;</a>"+replaceMathsTags(feedback.comment).replaceAll("\n","<br>")+"</div></li>");
   $("#feedback-"+feedback.feid).data("feid", feedback.feid);
   $("#feedback-"+feedback.feid+" .feedback-delete").click(function(){
      var feid = $(this).closest('li').data('feid');
      deleteFeedback(feid);
   });
}

function deleteFeedback(feid) {
   $.ajax({
      url: "/api/tasks/feedback/"+feid,
      type: "DELETE",
      contentType:false,
      processData: false,
      cache: false,
      dataType: "json",
      success: function(){
         $("#feedback-"+feid).remove();
      },
      error: function(j){
         dfmAlert("There was an error deleting this feedback:<br><br><strong>"+j.responseText+"</strong>");
      }
   });
   return false;
}

function submitQuestionFeedback(dom, isByQuestionAnalysis) {
   var userAnswer = dom.data("userAnswer");
   var comment = dom.find('textarea').val();
   var copy = dom.find('#copyfeedback:checked').length === 1 || isByQuestionAnalysis;

   let data = {
      aaid: userAnswer.aaid,
      qnum: userAnswer.qnum,
      message: comment,
      copy: copy
   }

   $.ajax({
      url: "/api/tasks/feedback",
      type: "POST",
      contentType: false,
      processData: false,
      cache: false,
      data: JSON.stringify(data),
      dataType: "json",
      success: function (feedback) {
         if (isByQuestionAnalysis) {
            dfmAlert("Feedback sent successfully.");
            dom.find('.feedback-addlink').show();
            dom.find('.feedback-add-row').hide();
         } else {
            addFeedbackRow(dom, feedback);
         }
         dom.find('textarea').val("");
         MathJax.typeset();
      },
      error: function (j, textStatus, errorThrown) {
         dfmAlert("There was an error sending this feedback:<br><br><strong>" + j.responseText + "</strong>");
      }
   });
}

function makeStudentRedo(aid, uid) {
   console.log("[MakeStudentRedo] aid = "+aid+", uid = "+uid);
   var data = {aid: aid, uid: uid};
   $.ajax({
      url: "/api/tasks/makestudentredo",
      type: "POST",
      contentType:false,
      processData: false,
      cache: false,
      dataType: "json",
      data: JSON.stringify(data),
      success: function(){
         dfmAlert("This student has been emailed to notify them that they need to restart this homework/assessment.");
      },
      error: function(jqXHR){
         dfmAlert("There was an error:<br><br><strong>"+jqXHR.responseText+"</strong>");
      }
   });
}


function getPublicName(user) {
   if (user.type == "teacher" || user.type == "admin" || user.type == "trust") {
      return user.title + (user.firstname ? " " + user.firstname[0] : "") + " " + user.surname;
   } else {
      return user.firstname + " " + user.surname;
   }
}

function overwriteMarkDialog(question, userAnswer, isExamMarking) {
   var dialogHTML = "<div><label style='display:inline-block;margin-bottom:10px;width:100px'>Current:</label>";
   if(isExamMarking) {
      // marksawarded not set unless it was partial marks.
      if(userAnswer.marksawarded===undefined)userAnswer.marksawarded = (userAnswer.iscorrect===true ? question.marks : 0);
      dialogHTML+= "<span style='font-weight:1000'>"+userAnswer.marksawarded+"/"+question.marks+"</span>";
   }
   else dialogHTML+= "<span style='font-weight:1000'>"+(userAnswer.iscorrect===true ? "Correct" : (userAnswer.iscorrect===false ? "Incorrect" : "Not Answered"))+"</span>";
   dialogHTML+= "</div>";
   dialogHTML+= "<div><label style='display:inline-block;margin-bottom:10px;width:100px'>Update to:</label><select id='updateto'>";
   if(isExamMarking) {
      for(var i=0; i<=question.marks; i++)dialogHTML+= "<option value='"+i+"'>"+i+"/"+question.marks+"</option>";
   } else {
      dialogHTML+= "<option value='0'>Incorrect</option><option value='1'>Correct</option>";
   }
   dialogHTML+= "</select></div>";
   dfmDialog(dialogHTML, [{label: "Update", action: function(){
      const updateto = parseInt($("#updateto").val());
      var data = {
         aaid: userAnswer.aaid,
         qnum: userAnswer.qnum,
      }
      if (isExamMarking) {
         data['marksawarded'] = updateto;
      } else {
         data['iscorrect'] = !!updateto;
      }
      $.ajax({
         url: "/api/tasks/overridemark",
         type: "POST",
         contentType:false,
         processData: false,
         cache: false,
         data: JSON.stringify(data),
         dataType: "json",
         success: function(attempt){
            $.modal.close();
            // By using the original label, we don't need to fetch what attempt was out of.
            var performanceLabelParts = $("#analysis-student-"+userAnswer.uid+" label").text().split("/");
            if(isExamMarking)performanceLabelParts[0] = attempt.mmarks[0];
            else performanceLabelParts[0] = attempt.numcorrect[0];
            $("#analysis-student-"+userAnswer.uid+" label").html(performanceLabelParts.join("/"));
            // THIS CODE IS HORRIBLY MESSY. Should just have one method somewhere which generates content of Full Breakdown cell/attempt row:
            var cell = $("#analysis-student-"+userAnswer.uid+"-"+userAnswer.qnum);   // 'Full Breakdown' tabe cell if viewing Task Analysis.
            var attemptRow = $("#studentattempt-"+attempt.aaid+"-"+userAnswer.qnum); // an answer row if viewing students attempts
            var attemptRowIsCorrect = attemptRow.find('.studentattempt-iscorrect');
            cell.removeClass('correct').removeClass('incorrect').removeClass('eventuallycorrect').removeClass('seen');
            attemptRow.removeClass('indicator-correct').removeClass('indicator-incorrect').removeClass('indicator-partialmarks').removeClass('indicator-seen');

            if(isExamMarking) {
               if(cell.is(':visible')) {
                  var existingTextParts = cell.text().split("/");
                  existingTextParts[0] = updateto;
                  cell.html(existingTextParts.join("/"));
                  if(updateto == existingTextParts[1])cell.addClass('correct');
                  else if(updateto == 0)cell.addClass('incorrect');
                  else cell.addClass('eventuallycorrect');
               } else {
                  var existingTextParts = attemptRowIsCorrect.text().split("/");
                  existingTextParts[0] = updateto;
                  attemptRowIsCorrect.html(existingTextParts.join("/"));
                  if(updateto == existingTextParts[1])attemptRow.addClass('indicator-correct');
                  else if(updateto == 0)attemptRow.addClass('indicator-incorrect');
                  else attemptRow.addClass('indicator-partialmarks');
               }
            }
            else {
               if(cell.is(':visible')) {
                  cell.find("img").attr("src", "/images/"+(updateto==1 ? "tick" : "cross")+"_icon.svg");
                  cell.addClass(updateto==1 ? "correct" : "incorrect");
               } else {
                  attemptRowIsCorrect.find('img').attr("src", "/images/"+(updateto==1 ? "tick" : "cross")+"_icon.svg");
                  attemptRow.addClass(updateto==1 ? "indicator-correct" : "indicator-incorrect");
               }
            }
         },
         error: function(j) {
            dfmAlert("An error occurred when trying to update the mark: <strong>"+j.responseText+"</strong>");
         }
      });

   }}], true);
}

var TYPE_COURSE = "c";
var TYPE_MODULE = "m";
var TYPE_UNIT = "u";

function loadProgressStatistics() {
   console.log("[LoadingProgressStatistics]");
   $("#tabs-studentprogress .instructional-message").hide();
   $("#progress-summary-maincounts span").html("-");
   $("#progress-summary-masterycounts .val").html("-");

   var isCumulative = $("#progress-summary-grouping").val()=="cumulative";
   if(isCumulative) {
      $("#progress-summary-cumulative").show();
      $("#progress-summary-byindividual").hide();
   } else {
      $("#progress-summary-cumulative").hide();
      $("#progress-summary-byindividual").show();
   }

   var studentSelection = $("#studentprogress-header-students").val();
   if(!studentSelection)return;
   var data = {
      datefrom: $("#progress-summary-datefrom").val(),
      dateto: $("#progress-summary-dateto").val(),
      studentselection: JSON.parse(studentSelection),
      iscumulative: isCumulative
   }
   $.ajax({
      url: "/api/progress/stats",
      type: "POST",
      contentType:false,
      processData: false,
      cache: false,
      data: JSON.stringify(data),
      dataType: "json",
      success: function(data){
         var stats = data.stats;
         $("#progress-bycourse > div").show();
         if(isCumulative) {
            $("#progress-summary-teachertaskcount").html(numberWithCommas(stats.teachertaskcount));
            $("#progress-summary-practicetaskcount").html(numberWithCommas(stats.practicetaskcount));
            $("#progress-summary-totalquestioncount").html(numberWithCommas(stats.totalquestioncount));
            $("#progress-summary-practicequestioncount").html(numberWithCommas(stats.practicequestioncount));
            $("#progress-summary-pointsearned").html(numberWithCommas(stats.pointsearned));
            $("#progress-summary-totalmastery").html(numberWithCommas(Math.round(stats.totalmastery)));
            $("#progress-summary-videowatchtime").html(formatVideoLength(stats.videowatchtime));
            for(var i=3; i>=0; i--)$("#progress-summary-masterycounts"+i+" .val").html(stats.masterycounts[i]);
         } else {
            $("#progress-summary-byindividual tbody").empty();
            $.each(data.uids, function(k, uid) {
               var stat = stats[uid];
               $("#progress-summary-byindividual tbody").append("<tr id='progress-summary-"+uid+"'></tr>");
               var row = $("#progress-summary-"+uid);
               row.append("<td>"+stat._user.surname+", "+stat._user.firstname+"</td>");
               row.append("<td>"+stat.totalquestioncount+"</td>");
               row.append("<td>"+stat.practicequestioncount+"</td>");
               row.append("<td>"+stat.pointsearned+"</td>");
               row.append("<td>"+formatVideoLength(stat.videowatchtime)+"</td>");
               row.append("<td>"+numberWithCommas(Math.round(stat.totalmastery))+"</td>");
               for(var i=0; i<=3; i++)row.append("<td>"+stat.masterycounts[i]+"</td>");
            });
         }
      },
      error: function(j) {
         dfmAlert("An error occurred when trying to lookup the student selection label: <strong>"+j.responseText+"</strong>");
      }
   });

   // Deal with course navigation.
   buildCourseSelectElement($("#progress-bycourse-course"))
   .then(function() {
      $("#progress-bycourse-course").change(function(){
         var coid = Number($(this).val());
         $("#progress-bycourse-module").toggle(!!coid);
         if(!coid)return;
         $.ajax({
            url: "api/course/course/"+$(this).val(),
            type: "GET",
            contentType:false,
            processData: false,
            cache: false,
            success: function(course){
               $('body').data('lastcourseselection', course);
               $("#progress-bycourse-module").empty().append("<option disabled selected>Select a module</option>");
               $("#progress-bycourse-unit").hide();
               $.each(course.modules, function(keym,module){
                  $("#progress-bycourse-module").append("<option value='"+module.cmid+"'>"+module.name+"</option>");
               });
               loadMastery(JSON.parse($("#studentprogress-header-students").val()), coid, TYPE_COURSE);
            }
         });
      });
   
      $("#progress-bycourse-module").change(function(){
         var cmid = Number($(this).val());
         $("#progress-bycourse-unit").toggle(!!cmid);
         if(!cmid)return;
   
         // Get correct module.
         var course = $('body').data('lastcourseselection');
         var module;
         $.each(course.modules, function(k,m) {
            if(m.cmid == cmid)module = m;
         });
         $("#progress-bycourse-unit").empty().append("<option disabled selected>Select a unit</option>");
         $.each(module.units, function(keyu,unit){
            $("#progress-bycourse-unit").append("<option value='"+unit.cuid+"'>"+unit.name+"</option>");
         });
         loadMastery(JSON.parse($("#studentprogress-header-students").val()), cmid, TYPE_MODULE);
      });
   
      $("#progress-bycourse-unit").change(function(){
         var cuid = Number($(this).val());
         if(!cuid)return;
         loadMastery(JSON.parse($("#studentprogress-header-students").val()), cuid, TYPE_UNIT);
      });
   });
}

function loadMastery(studentselection, id, entityType) {
   console.log("[GetMasteryCurrent] "+JSON.stringify(studentselection)+" id="+id+" entityType="+entityType);

   if(!id)id = 0;
   $("#progress-bycourse-current").show();
   $("#progress-bycourse-graph").hide();
   $("#progress-bycourse-nodata").hide();

   var data = {studentselection: studentselection, id: id, type: entityType};
   console.log("[DataToSend] "+JSON.stringify(data));

   $.ajax({
      url: "/api/progress/currentmastery",
      type: "POST",
      contentType:false,
      processData: false,
      data: JSON.stringify(data),
      dataType: "json",
      cache: false,
      success: function(data){
         var headByTopic = $("#progress-bycourse-current thead");
         var bodyByTopic = $("#progress-bycourse-current tbody");
         headByTopic.html("<th></th>");
         bodyByTopic.empty();

         // Table headings
         $.each(data.ids, function(k,colId) {
            headByTopic.append("<th>"+data.columns[colId]+"</th>");
         });

         $.each(data.uids, function(k,uid) {
            var student = data.students[uid];
            // Work out number of attempts.
            var numAttempts = 0;
            bodyByTopic.append("<tr id='progress-bycourse-student-"+uid+"'><td class='clickable'><span>"+student.surname+", "+student.firstname+"</span></td></tr>");
            var rowByTopic = $("#progress-bycourse-student-"+uid);

            $.each(data.ids, function(k2,colId) {
               var performance = data.mastery[uid] ? data.mastery[uid][colId] : undefined;
               rowByTopic.append("<td id='progress-bycourse-cell-"+uid+"-"+colId+"' class='progress-bycourse-accuracy'></td>");
               var cell = $("#progress-bycourse-cell-"+uid+"-"+colId);
               if(performance) {
                  cell.html(Math.round(performance)+(colId.charAt(0)=="s" ? "<span class='mastery-bar'>"+performance+"</span>" : ""));
                  if(colId.charAt(0)=="s") {
                     cell.find('.mastery-bar').dfmMasteryBar();
                     if(performance>85)cell.css('color', '#A330BA');
                     else if(performance>50)cell.css('color', '#92D050');
                     else if(performance>20)cell.css('color', '#E6CA17');
                     else cell.css('color', '#D9D9D9');
                  }
               }
            });
         });
         MathJax.typeset();
      },
      error: function(j) {
         dfmAlert("An error occurred: <strong>"+j.responseText+"</strong>");
      }
   });
}

function prepareDataForGraph(data) {
   var times = [];
   // Get unique time values.
   var uidToIndexMap = {};
   var i = 0;
   $.each(data.timelines, function(uid, timeline) {
      $.each(timeline, function(i, snapshot) {
         if($.inArray(snapshot.d, times)==-1)times.push(snapshot.d);
      });
      uidToIndexMap[uid] = i++;
   });
   times.sort();

   // Start with the rows filled with nulls. We will fill in later.
   var rows = [];
   var timeToRowIndexMap = {};
   var numStudents = data.uids.length;
   for(var i=0; i<times.length; i++) {
      rows.push([new Date(times[i]*1000)].concat(Array(numStudents).fill(undefined)));
      timeToRowIndexMap[times[i]] = i;
   }

   $.each(data.timelines, function(uid, timeline) {
      $.each(timeline, function(i, snapshot) {
         rows[timeToRowIndexMap[snapshot.d]][uidToIndexMap[uid]+1] = parseFloat(snapshot.mastery);
      });
   });

   // For each student, fill in the gaps in the graph.
   for(var s=1; s<=numStudents; s++) {
      var valueToRepeat = undefined;
      for(var r=0; r<rows.length; r++) {
         if(rows[r][s]==undefined)rows[r][s] = valueToRepeat;
         else valueToRepeat = rows[r][s];
      }
   }

   return rows;
}

function getTaskType(atype) {
   if(atype==="c")return "Independent Practice";
   else if(atype==="a")return "Formal Assessment";
   else if(atype==="t")return "Homework";
   else if(atype==="x")return "Teacher-set Topic Test";
   else if(atype==="z")return "Clean Up Task";
   else if(atype==="p")return "Independent Topic Test";
   else if(atype==="ka")return "Assessent";
   else if(atype==="kt")return "Homework";
   else if(atype==="kc")return "Practice";
   else if(atype==="ksz")return "Cleanup";
   else if(atype==="ut")return "Course Unit Test";
   else if(atype==="mt")return "Course Module Test";
   else if(atype==="kcc")return "Course Practice";
   else if(atype==="cc")return "Course Exam Skill Practice";
}

function loadActivityLog() {
   console.log("[LoadingActivityLog]");

   $("#progress-activity-table tbody").empty();
   var data = {};
   if($("#studentprogress-header-students").val()) {
      data.studentselection = JSON.parse($("#studentprogress-header-students").val());
   } else {
      return;
   }
   data.datefrom = $("#progress-activity-datefrom").val();
   data.dateto = $("#progress-activity-dateto").val();
   data.type = JSON.parse($("#progress-activity-type").val());
   data.activitylog = true;
   console.log("/api/tasks/list "+JSON.stringify(data));
   $.ajax({
      url: "/api/tasks/list",
      type: "POST",
      contentType:false,
      processData: false,
      cache: false,
      data: JSON.stringify(data),
      dataType: "json",
      success: function(data){
         console.log("Num results: "+data.tasks.length);
         $("#progress-activity").show();

         $.each(data.tasks, function(k,task) {
            // console.log(JSON.stringify(task));
            var attempt = task.attempts[0]; // for the Activity Log, each Task should have exactly one TaskAttempt, because it's effectively a list of attempts rather than tasks.

            $("#progress-activity-table tbody").append("<tr id='progress-activityrow-"+attempt.aaid+"'>"
              +"<td>"+attempt._user.surname+", "+attempt._user.firstname+"</td>"
              +"<td><a href='#'>"+limitLength(task.text, 150)+"</a><br><small>"+getTaskType(task.type)+"</small></td>"
              +"<td>"+(attempt.timetaken ? formatTime(attempt.timetaken) : "")+"</td>"
              +"<td>"+timeSince(attempt.datestarted)+"</td>"
              +"<td>" + (attempt.numcorrect? "<span class='accuracy'>"+attempt.numcorrect[0]+"/"+attempt.numcompleted[0]+"</span>" : "n/a")+ "</td>"
              +"</tr>");
            $("#progress-activityrow-"+attempt.aaid).data('aaid', attempt.aaid);
            $("#progress-activityrow-"+attempt.aaid).click(function(){
               var aaid = $(this).data('aaid');
               returnTo = "activitylog";
               loadTask(aaid, false);
            });
         });
         if(data.tasks.length==0) {
            $("#progress-activity-table tbody").append("<tr><td><p>No matching activity. Try extending the date range.</p></td></tr>");
         }
         $("#progress-activity-table tbody .accuracy").each(function(){
            $(this).dfmAccuracyBar();
         });
         MathJax.typeset();
      },
      error: function(j) {
         dfmAlert("An error occurred when trying to lookup the student selection label: <strong>"+j.responseText+"</strong>");
      }
   });

}


// --------------------------------------
// -- Page state management
// --------------------------------------

var currentPageState;

window.onpopstate = function(e){
   if(e.state)loadFromPageState(e.state, true);
};

/**
 * Some arrivals at progress.php will have a "from"
 * query parameter which will allow us to identify
 * a trigger ID for certain events.
 */
let posthogFrom = null;

function loadFromPageState(state, retrievingState) {
   console.log("[RetrievingState] state="+JSON.stringify(state)+" retrieving="+retrievingState);
   currentPageState = state;

   /**
    * Extract the "from" property before removing it
    * from the state object and the URL.
    */
   if (state.from) {
      posthogFrom = state.from;
      delete state.from;
      const url = new URL(window.location);
      url.searchParams.delete("from");
      window.history.replaceState(state, null, url);
   }

   if(currentPageState.mode) {
      $("#progress-menu").dfmSideMenu("selectTab", "tabs-"+currentPageState.mode);
   }
   else if(currentPageState.aid) {
      $("#tabs-tasklist").show();
      $("a[href='#tabs-tasklist']").addClass('selected');
      loadTask(currentPageState.aid, true);
   }
   else if(currentPageState.aaid) {
      loadTask(currentPageState.aaid, false);
   }
   else {
      $("#progress-menu").dfmSideMenu("selectTab", "tabs-tasklist");
   }

}

function saveState(title, url) {
   console.log("[SaveState] title="+title+" url="+url+" currentPageState="+JSON.stringify(currentPageState));
   document.title = title;
   window.history.pushState(currentPageState, null, url);

}
